module.exports = __webpack_public_path__ + "img/129.c80aefa5.jpg";